import { render, staticRenderFns } from "./XSnackbar.vue?vue&type=template&id=1978d154"
import script from "./XSnackbar.vue?vue&type=script&lang=js"
export * from "./XSnackbar.vue?vue&type=script&lang=js"
import style0 from "./XSnackbar.vue?vue&type=style&index=0&id=1978d154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports